// extracted by mini-css-extract-plugin
module.exports = {"patientName":"Table_patientName__17ZKY","productName":"Table_productName__2K-K8"};